const containerss = document.querySelector(".multi_images")
document
  .querySelector(".after_before_slider")
  .addEventListener("input", (e) => {
    containerss.style.setProperty("--position", `${e.target.value}%`)
  })

document
  .querySelectorAll(".after_before_bottom_text .before_text")
  .forEach(function (element) {
    element.addEventListener("click", function (event) {
      containerss.style.setProperty("--position", "100%")
    })
  })

document
  .querySelectorAll(".after_before_bottom_text .after_text")
  .forEach(function (element) {
    element.addEventListener("click", function (event) {
      containerss.style.setProperty("--position", "0%")
    })
  })
